export default __webpack_public_path__ + "static/media/dropbox.60b99117.png";